<script setup lang="ts">
import { computed } from 'vue'

import { buttonVariants } from '@satch-ui/components/button/variants'
import CartLineItem from '@satch-ui/components/line/shopify/CartLineItem.vue'
import { t } from '@satch-ui/translations/translations'
import { localizeUrl } from '@shared/fondof-fn/url/localize'
import type { CartLine } from '@shared/shop-api/cart/lines/types'

import { CartWideIcon } from '@fond-of/satch-icons'
import { vE2eTestId } from '@fond-of/telemetry'

const props = defineProps<{
  lines: CartLine[]
}>()

const cartQuantity = computed(() =>
  props.lines.reduce(
    (cartQuantity: number, line: CartLine) => cartQuantity + line.quantity,
    0
  )
)
</script>

<template>
  <div
    v-e2e-test-id="'floatingCartItems'"
    class="flex h-full flex-col"
  >
    <div class="text-md font-sans-bold text-black lg:text-center">
      {{ t('cart.title') }}
    </div>

    <div class="text-gray-medium mb-2.5 text-xs">
      {{ cartQuantity }} {{ t('cart.article') }}
    </div>

    <div
      class="scrollbar-black -mx-5 mb-5 h-full max-h-64 space-y-5 overflow-y-auto px-5 lg:mb-8 lg:space-y-8"
    >
      <a
        v-for="line in lines"
        :key="line.id"
        class="block"
        :href="localizeUrl(line.variant.product.url)"
      >
        <CartLineItem :line="line" />
      </a>
    </div>

    <a
      v-e2e-test-id="'floatingCartToCartButton'"
      data-slot="button"
      :class="['w-full', buttonVariants({ variant: 'primary' })]"
      :href="localizeUrl('/cart')"
    >
      {{ t('cart.toCart') }}

      <CartWideIcon class="size-4" />
    </a>
  </div>
</template>
